import React from 'react';
import Dropdown from './Dropdown';

const MessagesDropdown = () => {
  const messages = [
    {
      title: 'John Doe',
      description: 'Hi, how are you doing?',
      timestamp: '2 hrs ago',
      icon: '',
      link: '#',
      className: 'message-item',
    },
    {
      title: 'Jane Smith',
      description: 'Can you check the report?',
      timestamp: '4 hrs ago',
      icon: '',
      link: '#',
      className: 'message-item',
    },
  ];

  return (
    <Dropdown
      icon="bi-chat-left-text"
      badgeCount={messages.length}
      title="You have new messages"
      items={messages}
      footerAction={{ text: 'View all messages' }}
    />
  );
};

export default MessagesDropdown;
